/* ============================================
   LEOR RADIANCE REWARDS - DATA
   All program data extracted from artifact
   ============================================ */

export const TIERS = [
  {
    id: 'bloom',
    name: 'Bloom',
    icon: '🌷',
    meaning: 'Every glow starts here',
    spend: '₹0 – ₹49,999',
    spendRange: [0, 49999],
    earn: '1x',
    earnRate: 1,
    earnLabel: '1 GP per ₹100',
    discount: '5%',
    colorVar: '--tier-bloom',
    gradientClass: 'bg-tier-bloom',
    benefits: [
      '1 Glow Point per ₹100 spent',
      '500 GP welcome bonus on enrollment',
      '2x GP on all birthday month treatments',
      '5% off all treatments via app',
      'Digital aftercare guides post-treatment',
      'Real-time app booking',
      'Treatment history in My Journey',
      'Referral: 500 GP per friend who books',
      'Progress photo tracking',
      'Leor Skin Tips content access',
    ],
  },
  {
    id: 'lustre',
    name: 'Lustre',
    icon: '✨',
    meaning: 'Your glow is getting noticed',
    spend: '₹50K – ₹1.5L',
    spendRange: [50000, 150000],
    earn: '1.5x',
    earnRate: 1.5,
    earnLabel: '1.5 GP per ₹100',
    discount: '8%',
    colorVar: '--tier-lustre',
    gradientClass: 'bg-tier-lustre',
    benefits: [
      '1.5 GP per ₹100 (50% more than Bloom)',
      '1,000 GP tier achievement bonus',
      'Priority booking: 3 weeks advance',
      '1 free add-on per quarter',
      'Birthday: free Oxygen Infusion Facial',
      '10% off home care products',
      '8% off all treatments via app',
      'Seasonal 2x GP campaigns (4/year)',
      'Referral: 750 GP + friend gets 750',
      '1-year anniversary gift',
    ],
  },
  {
    id: 'aura',
    name: 'Aura',
    icon: '🌟',
    meaning: 'You radiate confidence',
    spend: '₹1.5L – ₹5L',
    spendRange: [150000, 500000],
    earn: '2x',
    earnRate: 2,
    earnLabel: '2 GP per ₹100',
    discount: '12%',
    colorVar: '--tier-aura',
    gradientClass: 'bg-tier-aura',
    benefits: [
      '2 GP per ₹100 (double Bloom)',
      '2,500 GP tier achievement bonus',
      'Priority booking: 4 weeks + waitlist',
      'Lock preferred doctor for all visits',
      '1 complimentary Hydra Facial/year',
      'Birthday: choice of signature facial free',
      'Early access to new treatments',
      '15% off home care products',
      '12% off all treatments via app',
      'Leor Concierge WhatsApp (15-min reply)',
    ],
  },
  {
    id: 'luminary',
    name: 'Luminary',
    icon: '👑',
    meaning: 'Your glow inspires others',
    spend: '₹5L – ₹10L',
    spendRange: [500000, 1000000],
    earn: '3x',
    earnRate: 3,
    earnLabel: '3 GP per ₹100',
    discount: '15%',
    colorVar: '--tier-luminary',
    gradientClass: 'bg-tier-luminary',
    benefits: [
      '3 GP per ₹100 (3x Bloom)',
      '5,000 GP tier bonus',
      'Dedicated care coordinator',
      'Same-day booking (reserved slots)',
      '2 facials + 1 body treatment/year free',
      'Birthday: any treatment up to ₹10K free',
      'VIP room at both locations',
      '48-hour post-treatment check-in',
      'Exclusive events (2-3/year)',
      '20% off products',
    ],
  },
  {
    id: 'leorglow',
    name: 'Leor Glow',
    icon: '💎',
    meaning: 'The ultimate radiance',
    spend: '₹10L+',
    spendRange: [1000000, Infinity],
    earn: '5x',
    earnRate: 5,
    earnLabel: '5 GP per ₹100',
    discount: '20%',
    colorVar: '--tier-leorglow',
    gradientClass: 'bg-tier-leorglow',
    benefits: [
      '5 GP per ₹100 (5x Bloom, highest)',
      '15,000 GP tier bonus',
      'Personal Leor Ambassador',
      'Anytime booking via Ambassador',
      '4 facials + 2 body + 1 premium/year free',
      'Birthday: ANY treatment free + home gift',
      'Private treatment experience',
      'Family: 3 at Aura + 1 partner at Luminary',
      'Quarterly at-home service',
      'Glow Points never expire',
    ],
  },
];

export const EARN_METHODS = [
  { title: 'Every Treatment', desc: 'Earn GP on every ₹100 spent — rate grows with your tier', icon: 'Sparkles', gp: '1–5 GP/₹100' },
  { title: 'Referral Bonus', desc: 'Invite friends and both earn generous GP rewards', icon: 'Users', gp: '500–1,000 GP' },
  { title: 'Birthday Month', desc: '2x points on all treatments during your birthday month', icon: 'Gift', gp: '2x multiplier' },
  { title: 'Google Review', desc: 'Leave a verified review and earn a one-time bonus', icon: 'Star', gp: '250 GP' },
  { title: 'Monthly Streaks', desc: 'Visit at least once a month for cumulative streak bonuses', icon: 'Flame', gp: 'Up to 2,000 GP' },
  { title: 'Social Posts', desc: 'Tag @leor.clinics on Instagram for bonus points', icon: 'Camera', gp: '100 GP (4x/yr)' },
  { title: 'Complete Package', desc: 'Finish all sessions in a treatment package for bonus GP', icon: 'CheckCircle', gp: '500 GP' },
  { title: 'Progress Photos', desc: 'Upload your treatment progress for small but steady GP', icon: 'Image', gp: '50 GP (12x/yr)' },
];

export const REDEEM_CATEGORIES = [
  {
    category: 'Facials',
    treatments: [
      { name: 'Hydra Facial', gp: 5000, value: '₹2,500' },
      { name: 'Celebrity Glow', gp: 8000, value: '₹4,000' },
      { name: 'Boto Glow', gp: 7000, value: '₹3,500' },
      { name: 'Vampire Facial', gp: 10000, value: '₹5,000' },
      { name: 'Oxygen Infusion', gp: 4000, value: '₹2,000' },
    ],
  },
  {
    category: 'Hair',
    treatments: [
      { name: 'GFC Therapy', gp: 12000, value: '₹6,000' },
      { name: 'PRP Treatment', gp: 10000, value: '₹5,000' },
      { name: 'Mesotherapy', gp: 6000, value: '₹3,000' },
    ],
  },
  {
    category: 'Body',
    treatments: [
      { name: 'Emsculpt Neo', gp: 25000, value: '₹12,500' },
      { name: 'Cryotherapy', gp: 8000, value: '₹4,000' },
      { name: 'Glow IV Drip', gp: 6000, value: '₹3,000' },
    ],
  },
  {
    category: 'Face',
    treatments: [
      { name: 'Lip Fillers', gp: 20000, value: '₹10,000' },
      { name: 'Morpheus 8', gp: 30000, value: '₹15,000' },
      { name: 'Ulthera Prime', gp: 45000, value: '₹22,500' },
      { name: 'Liftera', gp: 20000, value: '₹10,000' },
    ],
  },
];

export const BADGES = [
  { name: 'First Glow', desc: 'Complete your first treatment', gp: 100, cat: 'achievement' },
  { name: 'Glow Getter', desc: 'Complete 5 treatments', gp: 300, cat: 'achievement' },
  { name: 'Radiance Regular', desc: 'Complete 15 treatments', gp: 750, cat: 'achievement' },
  { name: 'Glow Master', desc: 'Complete 30 treatments', gp: 1500, cat: 'achievement' },
  { name: 'Leor Legend', desc: 'Complete 50 treatments', gp: 3000, cat: 'achievement' },
  { name: 'Explorer', desc: 'Try 4 treatment categories', gp: 500, cat: 'achievement' },
  { name: 'Glow Influencer', desc: 'Refer 3 friends', gp: 500, cat: 'achievement' },
  { name: 'Circle of Glow', desc: 'Refer 10 friends', gp: 2000, cat: 'achievement' },
  { name: 'Summer Glow', desc: '3 treatments May-Jul', gp: 500, cat: 'seasonal' },
  { name: 'Festive Radiance', desc: '2 treatments pre-Diwali', gp: 500, cat: 'seasonal' },
  { name: 'Winter Wellness', desc: 'Body + facial Dec-Feb', gp: 500, cat: 'seasonal' },
  { name: 'Night Owl', desc: 'Book 10PM–midnight', gp: 250, cat: 'secret' },
  { name: 'Both Sides', desc: 'Visit KP + Aundh', gp: 300, cat: 'secret' },
  { name: 'Full Moon', desc: 'Facial on a full moon', gp: 200, cat: 'secret' },
];

export const FAMILY_FEATURES = [
  { title: 'Shared Family Wallet', desc: 'Pool points together — spend collectively on any treatment' },
  { title: 'Combined Tier Progress', desc: 'All family spending counts toward the primary member\'s tier' },
  { title: 'Gift Treatments', desc: 'Transfer Glow Points to family members as gifts' },
  { title: 'Family Scheduling', desc: 'Book appointments together, manage everyone\'s calendar' },
  { title: 'Family Birthdays', desc: 'Every family member gets 2x GP on their birthday month' },
  { title: 'Anniversary Reward', desc: 'Extra GP bonus on your family group anniversary' },
];

export const COUPLE_PACKAGES = [
  { name: 'The Couple Glow', desc: 'Signature facial for two with complimentary champagne', earn: '1.5x GP' },
  { name: 'Wedding Prep Duo', desc: 'Comprehensive pre-wedding skin & body packages', earn: '1.5x GP' },
  { name: 'Anniversary Retreat', desc: 'Indulgent treatments with exclusive couple perks', earn: '1.5x GP' },
  { name: 'Parent-Child Glow', desc: 'Bond over beauty with age-appropriate treatments', earn: '1.5x GP' },
];
